import { useContext, useRef, useState } from 'react';
import { BatchUploadContext } from 'providers/bim-provider';
import { ContentWrapper, SelectMenu, Checkbox, Textbox } from 'components/generic';
import { getValuesById } from 'utils';
import Images from 'assets/Images';
import './style.scss';
import { incrementalLoadList } from 'config';

function ManualUpload() {
	const context = useContext(BatchUploadContext);
	const { createObj, setCreateObj } = context;
	const [uploadPercentage, setUploadPercentage] = useState();
	const reader = new FileReader();
	const inputfile = useRef();

	// to calculator the percent the file upload
	const handleEvent = event => {
		const percent = Math?.floor((event?.loaded * 100) / event?.total);
		setUploadPercentage(percent);
		if (event?.type === 'load') {
			return;
		}
	};

	// pasing the state progress, loadend,load....
	const addListeners = reader => {
		reader?.addEventListener('load', handleEvent);
		reader?.addEventListener('progress', handleEvent);
	};

	// data handler to create obj
	const dataManualUpload = (e, key) => {
		if (key === 'file') {
			if (e) {
				setUploadPercentage(0);
				addListeners(reader);
				reader.readAsDataURL(e);
				inputfile.current.value = null;
			}
		} else {
			key === 'bfm_loadCode' && setCreateObj(prevState => ({ ...prevState, bfm_version: getValuesById(context?.mappingList, e)[0]?.bfm_version }));
		}
		key && setCreateObj(prevState => ({ ...prevState, [key]: e }));
	};

	return (
		<>
			<div className='manual-upload'>
				<ContentWrapper shadow>
					<div className='row'>
						<div className='col-5'>
							<Textbox label='Product Name' infoContent='Select Product Name' placeholder='Enter' value={createObj?.p_code} onChange={e => dataManualUpload(e?.target?.value, 'p_code')} mandatory />
						</div>
					</div>
					<div className='row'>
						<div className='col-5'>
							<SelectMenu
								infoContent='Select Batch File Mapping'
								label='Batch File Mapping'
								placeholder='Select '
								value={getValuesById(context?.mappingList, createObj?.bfm_loadCode)}
								mandatory
								onChange={e => dataManualUpload(e, 'bfm_loadCode')}
								menuOptions={context?.mappingList}
							/>
						</div>
					</div>
					{process.env.REACT_APP_STANDALONE_APP === 'Y' && (
						<div className='row'>
							<div className='col-5'>
								<SelectMenu
									infoContent='Select Upload Type'
									label='Upload Type'
									placeholder='Select '
									value={getValuesById(incrementalLoadList, createObj?.bfm_uploadLoadType)}
									mandatory
									onChange={e => dataManualUpload(e, 'bfm_uploadLoadType')}
									menuOptions={incrementalLoadList}
								/>
							</div>
						</div>
					)}
					<div className='row'>
						<div className='col-5'>
							<div className='manual-upload__user'>
								<label>
									Upload File <sup>*</sup>
								</label>
								<div className='manual-upload__userfile'>
									<img src={Images?.manualUpload} alt='upload' onClick={() => setUploadPercentage(0)} />
									<input ref={inputfile} type='file' onChange={e => dataManualUpload(e?.target?.files[0], 'file')} />
								</div>

								{createObj.file && (
									<div className='manual-upload__upload-file'>
										<div className='manual-upload__upload-file__icon'>
											<img src={Images[createObj.file.name.match(/\.[0-9a-z]+$/i)[0].substr(1)]} alt='Images' width='15px' height='15px' />
										</div>
										<div className='manual-upload__upload-file__info'>
											<span>
												<h4>{createObj?.file.name}</h4>
											</span>
											<div className='manual-upload__file-loader'>
												<div className='manual-upload__file-loader__loader' style={{ width: `${uploadPercentage}%` }}></div>
											</div>
										</div>
										<div className='manual-upload__upload-file__delete'>
											<img src={Images?.close} alt='close' onClick={() => setCreateObj(prevState => ({ ...prevState, file: '' }))} />
										</div>
										<div className='manual-upload__upload-file__success'>
											<img src={Images?.assignedTick} alt='tick' />
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='col-5'>
							<p>Or</p>
							<Checkbox content='Pick from Server' value='SERVER' checked={createObj?.uploadFrom} onClick={e => dataManualUpload(e?.target?.checked, 'uploadFrom')} />
						</div>
					</div>
				</ContentWrapper>
			</div>
		</>
	);
}

export default ManualUpload;
